import { Link } from 'react-router-dom';
import solutionData from '../data/solutionData';
import '../styles/FeaturedSolutions.css';

const FeaturedSolutions = () => {
  return (
    <section className="featured-solutions">
      <div className="featured-solutions-container">
        <header className="featured-solutions-header">
          <div>
            <span>Focused solutions</span>
            <h2>Solutions Built Around Real Business Needs</h2>
          </div>
          <Link to="/solutions">Explore Solutions <span aria-hidden="true">→</span></Link>
        </header>

        <div className="featured-solutions-grid">
          {solutionData.map((solution) => (
            <article className="featured-solution-card" key={solution.id}>
              <div className="featured-solution-mark" aria-hidden="true">S</div>
              <div>
                <h3>{solution.title}</h3>
                <p>{solution.homepageSummary || solution.summary}</p>
                <Link to={solution.path}>View solution <span aria-hidden="true">→</span></Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedSolutions;
